import { createAction } from '/@/store/utils';

export const setUser = createAction('PRODUCT_DATASHEET:SET_USER');
export const setZone = createAction('PRODUCT_DATASHEET:SET_ZONE');
export const setProductDatasheetType = createAction('PRODUCT_DATASHEET:SET_TYPE');
export const setProductDatasheetSlug = createAction('PRODUCT_DATASHEET:SET_NAME');
export const setProductDatasheetConfig = createAction('PRODUCT_DATASHEET:SET_CONFIG');
export const setProfileEnvironment = createAction('PRODUCT_DATASHEET:SET_PROFILE_ENVIRONMENT');
export const setMetric = createAction('PRODUCT_DATASHEET:SET_METRIC');
export const addProduct = createAction('PRODUCT_DATASHEET:ADD_PRODUCT');
export const removeProduct = createAction('PRODUCT_DATASHEET:REMOVE_PRODUCT');
export const addModule = createAction('PRODUCT_DATASHEET:ADD_MODULE');
export const removeModule = createAction('PRODUCT_DATASHEET:REMOVE_MODULE');
export const addExtra = createAction('PRODUCT_DATASHEET:ADD_EXTRA');
export const removeExtra = createAction('PRODUCT_DATASHEET:REMOVE_EXTRA');
export const addFeature = createAction('PRODUCT_DATASHEET:ADD_FEATURE');
export const removeFeature = createAction('PRODUCT_DATASHEET:REMOVE_FEATURE');
export const addMetric = createAction('PRODUCT_DATASHEET:ADD_METRIC');
export const removeMetric = createAction('PRODUCT_DATASHEET:REMOVE_METRIC');
export const addProducttoPreview = createAction('PRODUCT_DATASHEET:ADD_TO_PREVIEW');
export const setCompletePreview = createAction('PRODUCT_DATASHEET:SET_PREVIEW');
